export default {
  filters(state) {
    return state.items;
  },
};
